// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"cb560e1e","190":"27d9e0e3","453":"a1da7bd1","740":"e1914115","877":"7b3b9f31","905":"5f36f088","998":"23f8e140"}[chunkId] + ".chunk.js";
};